// extracted by mini-css-extract-plugin
export default {"fwrAuthHeader":"NewSignup_fwrAuthHeader__SM-DR","fwrLogo":"NewSignup_fwrLogo__2ie5w","fwrkSignup":"NewSignup_fwrkSignup__gNjPq"};